import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";

import AsyncComputed from "vue-async-computed";
import VeeValidate from "vee-validate";

import router from "@/router";
import store from "@/store/store";

import isMobileDirective from "./directives/is-mobile.directive";
import isTabletDirective from "./directives/is-tablet.directive";
import dateFilter from "./filters/date";
import localeMixin from "./mixins/locale.mixin";
import formMixin from "./mixins/form.mixin";
import dialogsMixin from "./mixins/dialogs.mixin";
import MultiFiltersPlugin from "./plugins/multifilter.plugin";

Vue.config.productionTip = false;

Vue.use(localeMixin);
Vue.use(formMixin);
Vue.use(dialogsMixin);
Vue.use(VeeValidate);
Vue.use(AsyncComputed);
Vue.use(MultiFiltersPlugin);

isMobileDirective();
isTabletDirective();

Vue.filter("date", dateFilter);

document.addEventListener('DOMContentLoaded', () => {
  const loader = document.getElementById('initial-loader');
  loader.classList.add('isActive');
  setTimeout(() => {
    new Vue({
      router,
      store,
      vuetify,
      render: h => h(App),
      mounted() {
        loader.classList.remove('isActive');
        setTimeout(() => loader.remove(), 1000);
      }
    }).$mount("#app");
  }, 2000);
});

